// React
import type { FC } from 'react';

// Refine
import { useTranslation } from '@refinedev/core';

// Mantine
import { Card, Group, Text } from '@mantine/core';

export interface IntakeNotesPanelProps {
  notes: string;
}

export const IntakeNotesPanel: FC<IntakeNotesPanelProps> = ({ notes }) => {
  const { translate } = useTranslation();
  return (
    <Card withBorder radius="md" padding="md">
      <Group align="center" wrap="wrap">
        <Text fw={500} size="sm">
          {translate('pages:uploads.uploadsModal.intakeNotes', 'Upload Notes')}
        </Text>
      </Group>
      <Text
        size="sm"
        c={notes?.trim() ? undefined : 'dimmed'}
        mt="sm"
        style={{ whiteSpace: 'pre-wrap' }}
      >
        {notes?.trim()
          ? notes
          : translate('pages:uploads.uploadsModal.noUploadNotes', 'No upload notes.')}
      </Text>
    </Card>
  );
};
